import { makeAutoObservable, observable, reaction, values, runInAction } from 'mobx'
import { RootStore } from '../RootStore'
import { BlazeFont, IBlazeFont } from './BlazeFont'
import { REACT_APP_READER_URL } from 'env'

export class BlazeFontsStore {
  rootStore: RootStore
  ready = false
  private _fonts = observable.map<IBlazeFont['family'], BlazeFont>()

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore

    reaction(
      () => this.rootStore.featureFlags.isActive('load_monotype_fonts'),
      (isActive) => {
        if (isActive) {
          this.fetchAll()
        }
      },
      { fireImmediately: true },
    )
  }

  load = (key: IBlazeFont['family']) => {
    const font = this._fonts.get(key)
    if (!font) {
      return
    }

    return font.load()
  }

  get = (key: IBlazeFont['family']) => {
    return this._fonts.get(key)
  }

  get list() {
    return values(this._fonts)
  }

  getByLoadingState = (...states: Array<BlazeFont['loadingState']>) => {
    return this.list.filter((font) => states.includes(font.loadingState))
  }

  addBulk = (items: IBlazeFont[]) => {
    items.forEach((item: IBlazeFont) => {
      this._fonts.set(item.family, new BlazeFont(item))
    })
  }

  fetchAll = async () => {
    if (!this.rootStore.featureFlags.isActive('load_monotype_fonts')) {
      runInAction(() => {
        this.ready = true
      })
      return
    }
    try {
      const res = await fetch(`${REACT_APP_READER_URL}/blaze_fonts`)
      const items = await res.json()
      this.addBulk(items)
      runInAction(() => {
        this.ready = true
      })
    } catch (error) {}
  }
}
